import { render } from "./ProductCarousel.vue?vue&type=template&id=5a2cfe62"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product/ProductCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a2cfe62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a2cfe62', __exports__)) {
    api.reload('5a2cfe62', __exports__)
  }
  
  module.hot.accept("./ProductCarousel.vue?vue&type=template&id=5a2cfe62", () => {
    api.rerender('5a2cfe62', render)
  })

}


export default __exports__